var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactionFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 35,
    viewBox: "0 0 34 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0105683 1.10223V4.35755H27.8617V1.28291C28.0063 0.270146 27.078 0.017066 26.5957 0.0171216H1.27653C0.119079 -0.127559 -0.0497154 0.680242 0.0105683 1.10223Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0107422 5.62226L27.681 5.44141V8.33502C25.571 8.99814 21.749 11.6265 23.3405 16.835H1.6384C1.09585 16.8953 0.0107422 16.7627 0.0107422 15.7499V5.62226ZM1.80857 7.95678H5.06389V9.04189H1.80857V7.95678ZM6.5107 7.95678H9.76602V9.04189H6.5107V7.95678ZM14.1064 7.95678H11.2128V9.04189H14.1064V7.95678ZM15.5533 7.95678H18.8086V9.04189H15.5533V7.95678ZM23.5107 7.95678H20.2554V9.04189H23.5107V7.95678ZM1.80857 13.744H5.06389V14.8291H1.80857V13.744Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9359 19.532C31.7326 19.532 33.9997 17.2648 33.9997 14.4681C33.9997 11.6715 31.7326 9.4043 28.9359 9.4043C26.1392 9.4043 23.8721 11.6715 23.8721 14.4681C23.8721 17.2648 26.1392 19.532 28.9359 19.532ZM30.9334 17.1738L28.9875 15.2278L27.1264 17.1665L26.405 16.474L28.2802 14.5206L26.4121 12.6525L27.1192 11.9454L28.9729 13.799L30.7454 11.9527L31.4668 12.6452L29.6801 14.5063L31.6405 16.4667L30.9334 17.1738Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionFailed);
export default __webpack_public_path__ + "static/media/transaction-failed.781c7d8323e1bd6b93369eb31c62f5d8.svg";
export { ForwardRef as ReactComponent };